import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import * as API from "../../Endpoints/Endpoints";
import "../../PlayDB/AddPlay/style.css";
import { motion } from "framer-motion";
import probingImage from "../../PlayDB/uploads/probing.png";
import { jwtDecode } from 'jwt-decode';
import { Mic } from "lucide-react";

const CardScenario = () => {
  const [selectedCardGroup, setSelectedCardGroup] = useState(null);
  const [cardGroups, setCardGroups] = useState([]);
  const [cards, setCards] = useState([]);
  const [openedCards, setOpenedCards] = useState([]); 
  const [loading, setLoading] = useState(false);
  const [flippedCardIndex, setFlippedCardIndex] = useState(null);
  const [gameCards, setGameCards] = useState([]); 
  const [gameStarted, setGameStarted] = useState(false); 
  const [userInput, setUserInput] = useState("");
  const [scenario, setscenario] = useState("");
  const [score, setScore] = useState(0);
  const navigate = useNavigate();
  const [gameCategories, setGameCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [gameNames, setGameNames] = useState([]);
  const [loadingNames, setLoadingNames] = useState(false);
  const [loadingGroups, setLoadingGroups] = useState(false);
  const [selectedGamename, setSelectedGamename] = useState(null);
  const [timerActive, setTimerActive] = useState(false);
  const [timeElapsed, setTimeElapsed] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [response, setResponse] = useState("");
  const [error, setError] = useState("");
  const [userId, setUserId] = useState('');
  const [email, setEmail] = useState("");
  const [selectedCardGroups, setSelectedCardGroups] = useState([]); 
  const [isListening, setIsListening] = useState(false);
  const [isFetchingResponse, setIsFetchingResponse] = useState(false);
  const [isFetchingScore, setIsFetchingScore] = useState(false);
  const [showGameOver, setShowGameOver] = useState(false);


  /////////fetching email//////////
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      const decoded = jwtDecode(token);
      const userId = parseInt(decoded.id, 10);
      setUserId(userId);
      localStorage.setItem("id", userId);
      setEmail(decoded.email); 
    } else {
    }
  }, []);

  ///////////////open ai integration///////////
  const handleFetchScore = async () => {
    const scoreprompt = `show overall score from the following ${response}`; 
    setIsFetchingScore(true);
    const scoreResponse = await sendPromptToAPI(scoreprompt, "score");
    setScore(scoreResponse); // Store score properly
    setIsFetchingScore(false);
};

const handleResponseFetch = async () => {
    const prompt = `Cardname: ${openedCards}\nScenario: ${scenario}\nUser Input: ${userInput} and also give critically score for entered scenario and userinput and combining show overall score out of 10 under the response`; 
    setIsFetchingResponse(true);
    const responseData = await sendPromptToAPI(prompt, "response");
    setResponse(responseData); // Store response properly
    setIsFetchingResponse(false);
};

const sendPromptToAPI = async (prompt, mode) => {
  const url = "https://api.openai.com/v1/chat/completions";
  const apiKey = "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"; 

    try {
        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${apiKey}`,
            },
            body: JSON.stringify({
                model: "gpt-4o-mini", 
                messages: [{ role: "user", content: prompt }],
                max_tokens: 500, 
            }),
        });

        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        const content = data.choices?.[0]?.message?.content || "No response";

        return content; // Return the response data
    } catch (err) {
        console.error("Error:", err.message);
        return "Error fetching data"; 
    }
};


  const handleCardFlip = (index) => {
    setFlippedCardIndex(index);
    setOpenedCards((prev) => {
        // Clone previous openedCards array
        const newOpenedCards = [...prev];
        // Ensure the card is not already stored to prevent duplicates
        const isCardExists = newOpenedCards.some(card => card.cardname === cards[index].cardname);
        if (!isCardExists) {
            newOpenedCards.push(cards[index]); 
        }
        console.log("Opened Cards Updated:", newOpenedCards); 
        return newOpenedCards;
    });
};
  
  const uniqueCardGroups = [...new Set(cardGroups.map((group) => group.cardgroup))];

  const shuffleArray = (array) => {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  };

  const handleGameStart = () => {
    setGameCards([...openedCards]); 
    setGameStarted(true);
    setTimerActive(true);
    setSelectedCardGroup(null);
    setCards([]);
    setFlippedCardIndex(null);
  };

  const handleUserInput = (event) => {
    setUserInput(event.target.value); 
  };

  //////////scenario///////
  const handleScenario = (event) => {
    setscenario(event.target.value);
  };

  const startListening = (field) => {
    const SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SpeechRecognition) {
      alert("Your browser does not support speech recognition.");
      return;
    }
  
    const recognition = new SpeechRecognition();
    recognition.continuous = false;
    recognition.interimResults = false;
    recognition.lang = "en-US";
  
    recognition.onstart = () => {
      setIsListening(true);
    };
  
    recognition.onresult = (event) => {
      const transcript = event.results[0][0].transcript;
  
      // Check which field needs to be updated
      if (field === "scenario") {
        setscenario(transcript);
      } else if (field === "userInput") {
        setUserInput(transcript);
      }
    };
  
    recognition.onend = () => {
      setIsListening(false);
    };
  
    recognition.onerror = (event) => {
      console.error("Speech Recognition Error:", event.error);
      setIsListening(false);
    };
  
    recognition.start();
  };
  
  ///////////API'S Data Fetch//////// 
  useEffect(() => {
    const fetchGameCategories = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("Token not available");
        return;
      }
      try {
        setLoading(true);
        const response = await axios.get(API.GET_GAME_CATEGORIES_API, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        console.log("API Response:", response.data);
        if (Array.isArray(response.data)) {
          setGameCategories(response.data);
        } else {
          console.error("Unexpected response format:", response.data);
        }
      } catch (error) {
        console.error("Error fetching game categories:", error);
      } finally {
        setLoading(false);
      }
    };
  
    fetchGameCategories();
  }, []);  
    
  const handleCategoryChange = async (event) => {
    const category = event.target.value;
    setSelectedCategory(category);
    setLoadingNames(true);
    setGameNames([]); 
    try {
      const response = await axios.get(`${API.GET_GAME_NAMES_API}/${category}`);
      if (response.status === 200) {
        setGameNames(response.data.gamenames);
      } else {
        alert("No game names found for this category.");
      }
    } catch (error) {
      console.error("Error fetching game names:", error);
      alert("Failed to fetch game names.");
    } finally {
      setLoadingNames(false);
    }
  };  
  
  useEffect(() => {
    const fetchGamenames = async () => {
      try {
        const response = await axios.get(API.GET_GAME_NAMES_API);
        const uniqueNames = [
          ...new Map(response.data.map(item => [item.gamename, item])).values()
        ];
        
        setGameCategories(uniqueNames);
      } catch (error) {
        console.error("Error fetching game names:", error);
      }
    }; 
    fetchGamenames();
  }, []);  

  const handleGamenameChange = async (event) => {
    const gamename = event.target.value;
    setSelectedGamename(gamename);
    setLoadingGroups(true);
    setCardGroups([]);   
    try {
      const response = await axios.get(`${API.GET_CARD_GROUPS_API}/${selectedCategory}/${encodeURIComponent(gamename)}`);
      if (response.status === 200) {
        setCardGroups(response.data.cardgroups);
      } else {
        alert("No card groups found for this game name.");
      }
    } catch (err) {
      console.error("Error fetching card groups:", err);
      alert("Failed to fetch card groups.");
    } finally {
      setLoadingGroups(false);
    }
  };

  useEffect(() => {
    const fetchCardNames = async () => {
      try {
        const response = await axios.get(API.GET_CARD_GROUPS_API);
        const uniqueCards = response.data.filter(
          (card, index, self) =>
            index === self.findIndex((c) => c.cardname === card.cardname)
        );
        setGameCategories(uniqueCards);
      } catch (error) {
        console.error("Error fetching card names:", error);
      }
    };
    fetchCardNames();
  }, []);

  const handleCardGroupCheckbox = async (e, selectedCardGroup) => {
    const isChecked = e.target.checked;
    setLoading(true);
    setSelectedCardGroups((prevSelected) => {
        let updatedGroups = isChecked
            ? [...prevSelected, selectedCardGroup]
            : prevSelected.filter(group => group !== selectedCardGroup);

        return updatedGroups;
    });
    try {
        await fetchCardsForGroups(e, selectedCardGroup);
    } catch (error) {
        console.error("Error fetching cards for groups:", error);
    } finally {
        setLoading(false); 
    }
};

const fetchCardsForGroups = async (e, selectedCardGroup) => {
  const isChecked = e.target.checked;
  setLoading(true);
  setSelectedCardGroups((prevSelected) => {
      if (isChecked) {
          return [...prevSelected, selectedCardGroup]; 
      } else {
          return prevSelected.filter((group) => group !== selectedCardGroup); 
      }
  });
  try {
      if (isChecked) {
          setCards([]);
          setFlippedCardIndex(null);
          const response = await axios.get(
              `${API.GET_CARD_NAMES_API}/${selectedCategory}/${selectedGamename}/${encodeURIComponent(selectedCardGroup)}`
          );
          console.log('Fetched Cards:', response.data);
          if (response.status === 200 && response.data?.cards?.length > 0) {
              setCards(response.data.cards);
          } else {
              alert("No cards found for this group.");
          }
      }
  } catch (err) {
      console.error("Error fetching cards:", err);
      alert("Failed to fetch cards.");
  } finally {
      setLoading(false);
  }
};

  useEffect(() => {
    const fetchCardnames = async () => {
      try {
        const response = await axios.get(API.GET_CARD_NAMES_API);
        const uniqueNames = [
          ...new Map(response.data.map(item => [item.gamename, item])).values()
        ];        
        setGameCategories(uniqueNames);
      } catch (error) {
        console.error("Error fetching game names:", error);
      }
    };
    fetchCardnames();
  }, []); 

  useEffect(() => {
    let interval;
    if (timerActive) {
      interval = setInterval(() => {
        setTimeElapsed((prevTime) => prevTime + 1);
      }, 1000); // Increment every second
    }
    return () => clearInterval(interval);
  }, [timerActive]);

  const handleGameOver = () => {
    window.location.reload(); 
  };
  

///////////db submission///////////
const handleGameSubmit = async () => {
  setTimerActive(false);
  const finalTime = timeElapsed;

  if (selectedCardGroups.length === 0) {
      alert("Please select at least one card group before submitting.");
      return;
  }

  const dataToSubmit = {
      score,  
      email,
      selectedCategory,
      selectedGamename,
      selectedCardGroups, 
      openedCards,
      scenario,
      userInput,
      response,
      timeElapsed: finalTime,
  };

  console.log("Submitting data:", dataToSubmit);
  try {
      const res = await axios.post(API.POST_PLAY_API, dataToSubmit);

      if (res.status === 200 || res.status === 201) {
          alert("Data submitted successfully!");

          // ✅ Reset only specific fields, keep Game Over button visible
          setOpenedCards([]);
          setscenario("");
          setUserInput("");
          setGameStarted(false);
          setTimerActive(false);
          setTimeElapsed(0);
          setScore(0);
          setResponse("");

          // ✅ Show "Game Over" button after submission
          setShowGameOver(true);
      } else {
          alert("Failed to submit data.");
      }
  } catch (error) {
      console.error("Error submitting data:", error);
      alert("Failed to submit data.");
  }
};

const handleRefresh = () => {
// Reset all necessary states here
setSelectedCategory(null);
setSelectedGamename(null);
setOpenedCards([]);
setscenario("");  // Correcting the case for 'scenario'
setUserInput("");
setGameStarted(false);
setTimerActive(false);
setTimeElapsed(0);
setScore(0);
setCardGroups([]);
setGameCategories([]);
setGameNames([]);
setLoading(true); 
setLoadingNames(true); 
setLoadingGroups(true); 

// Reload the page to clear everything
window.location.reload();
};

    
  return (
    <div className="flex min-h-screen bg-black">
      {/* Sidebar for Categories */}
      <div className="w-1/5 bg-gray-800 text-white p-4"> 

      <div className="mt-6 mb-6 relative"> {/* Adjust margin-bottom to create space */}
  <button
    onClick={handleRefresh}
    className="bg-[#e64a32] text-white px-4 py-2 rounded-lg hover:bg-[#e64a32] focus:outline-none absolute top-0 right-0"
  >
    Refresh
  </button>
</div>

<div>
<div className="mt-12"> {/* Increased margin-top for the Game Categories section */}
  <h2 className="text-lg font-bold mb-4">Game Categories</h2>
  {loading ? (
    <p className="text-gray-500">Loading categories...</p>
  ) : (
    <select
      value={selectedCategory || ""}
      onChange={handleCategoryChange}
      className="w-full bg-white text-black px-4 py-2 rounded-lg mb-3"
    >
      <option value="" disabled>
        {gameCategories.length > 0 ? "Select a Category" : "No Categories Available"}
      </option>
      {gameCategories.map((category, index) => (
        <option key={index} value={category.gamecategory}>
          {category.gamecategory}
        </option>
      ))}
    </select>
  )}
</div>


        {/* Game Names */}
        {selectedCategory && !loadingNames && (
          <div>
            <h2 className="text-lg font-bold mt-6">Game Names</h2>
            {loadingNames ? (
              <p className="text-gray-500 mt-4">Loading game names...</p>
            ) : (
              <select
                value={selectedGamename || ""}
                onChange={handleGamenameChange}
                className="w-full bg-white text-black px-4 py-2 rounded-lg mb-3"
              >
                <option value="">Select a Game Name</option>
                {gameNames.map((name) => (
                  <option key={name} value={name}>
                    {name}
                  </option>
                ))}
              </select>
            )}
          </div>
        )}

{selectedGamename && !loadingGroups && (
  <div>
    <h2 className="text-lg font-bold mt-6">Card Groups</h2>
    {loadingGroups ? (
      <p className="text-gray-500 mt-4">Loading card groups...</p>
    ) : (
      <div className="bg-white p-2 rounded-md border text-black">
        {cardGroups.map((group, index) => (
          <div key={index} className="flex items-center gap-2">
            <input
              type="checkbox"
              id={`cardGroup-${index}`}
              value={group}
              onChange={(e) => handleCardGroupCheckbox(e, group)} // Call updated handler
              className="cursor-pointer"
            />
            <label htmlFor={`cardGroup-${index}`} className="cursor-pointer">
              {group}
            </label>
          </div>
        ))}
      </div>
    )}
  </div>
)}

{openedCards.length > 0 && (
    <div className="mt-6">
   <button
      onClick={handleGameStart}
      className="w-full bg-white text-black px-4 py-2 rounded-lg hover:bg-gray-300 focus:outline-none animate-pulse"
    >
      Game Begins
    </button>

      {/* Show Game Started info after clicking Game Begins */}
      {gameStarted && timerActive && (
        <div className="game-started mt-4">
          <h3 className="text-lg font-semibold">Game Started!</h3>
          <p className="text-sm">Total Time Taken: {timeElapsed} seconds</p>
        </div>
      )}
     </div>
     )}

<div>
     {gameStarted && (
        <div className="mt-4">
         <div>
          <h3 className="text-lg font-semibold text-white mb-2">Enter Scenario</h3>
          <div className="relative">
            <textarea
              className="mt-4 p-2 border rounded w-full h-20 text-black pr-10"
              placeholder="Enter scenario"
              value={scenario}
              onChange={handleScenario}
            ></textarea>
            <button
              onClick={startListening}
              className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-600 hover:text-blue-500"
            >
              <Mic className={isListening ? "text-[#e64a32] animate-pulse" : ""} />
            </button>
          </div>
        </div>
      
        <div>
        <h4 className="text-lg font-semibold text-white mb-2">Enter User Input</h4>
        <div className="relative">
          <textarea
            className="mt-4 p-2 border rounded w-full h-20 text-black pr-10"
            placeholder="Enter input message"
            value={userInput}
            onChange={(e) => setUserInput(e.target.value)}
          ></textarea>
          <button
            onClick={() => startListening("userInput")}
            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-600 hover:text-blue-500"
          >
            <Mic className={isListening ? "text-[#e64a32] animate-pulse" : ""} />
          </button>
        </div>
      </div>

          <div>
    <button
      className="mt-4 px-4 py-2 bg-[#e64a32] text-white rounded hover:bg-[#e64a32] focus:outline-none"
      onClick={handleResponseFetch}
      disabled={isFetchingResponse || !openedCards || !scenario || !userInput}
    >
      {isFetchingResponse ? "Loading..." : "Get Response"}
    </button>
</div>

{/* Display the Score */}
<div className="mt-4">
    <button
      onClick={handleFetchScore}
      className="p-2 bg-[#e64a32] text-white rounded mb-4"
      disabled={isFetchingScore} // Disable when fetching score
    >
      {isFetchingScore ? "Loading..." : "Score"}
    </button>
</div>


          {/* Submit Button */}
          {/* Submit Button */}
<div className="mt-4">
  <button
    onClick={handleGameSubmit}
    className="w-full bg-[#e64a32] text-white px-4 py-2 rounded-lg hover:bg-[#e64a32] focus:outline-none"
  >
    Submit
  </button>
</div>
        </div>
      )}

      {/* Display Game Over message after Submit */}
      {!timerActive && score > 0 && (
        <div className="game-over mt-4">
          <h3 className="text-lg font-semibold">Game Over!</h3>
          <p className="text-sm">Total Time Taken: {timeElapsed} seconds</p>
        </div>
      )}
    </div>
            </div>

            {showGameOver && (
            <div className="mt-4">
              <button
                onClick={handleGameOver}
                className="w-full bg-[#e64a32] text-white px-4 py-2 rounded-lg hover:bg-[#e64a32] focus:outline-none"
              >
                Game Over
              </button>
            </div>
          )}
          </div>
      
        {/* Main Content Area */}
        <div className="flex-1 flex flex-col items-center justify-start p-6 min-h-screen bg-black">
        <div className="absolute right-0 top-0 mt-8 mr-8 w-80">
      <div className="mb-6">
        <label htmlFor="email" className="block text-lg font-medium text-gray-700">
          Email Address
        </label>
        <input
          type="email"
          id="email"
          name="email"
          value={email} // Automatically populate email
          className="mt-1 p-2 w-full border border-white rounded-md text-lg text-gray-800"
          readOnly // Make email field read-only
        />
      </div>
    </div>
    
      <h2 className="text-xl font-bold text-white mt-8 mb-8">Let's Play The Game !!</h2>
  
      {/* Show Loading or Cards */}
      {cards.length > 0 ? (
  <div className="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-5 gap-4 mt-6">
    {cards.map((card, index) => (
      <div
        className="scene"
        style={{ perspective: "1000px" }}
        key={index}
        onClick={() => handleCardFlip(index)}
      >
        <motion.div
          className="card"
          style={{
            width: "200px",
            height: "300px",
            position: "relative",
            transformStyle: "preserve-3d",
            transition: "transform 1s",
            cursor: flippedCardIndex === null ? "pointer" : "not-allowed",
            transform: flippedCardIndex === index ? "rotateY(180deg)" : "rotateY(0deg)",
          }}
        >
          {/* Front of the card */}
          <motion.div
            className="card_face card_face--front"
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              backfaceVisibility: "hidden",
              backgroundColor: "#ffffff",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "10px",
              borderRadius: "8px",
              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
            }}
          >
            <h3 className="text-sm font-sm text-gray-800">Click on the card</h3>
          </motion.div>

          {/* Back of the card */}
          <motion.div
            className="card_face card_face--back"
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              backfaceVisibility: "hidden",
              transform: "rotateY(180deg)",
              backgroundColor: "#ffffff",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              padding: "10px",
              borderRadius: "8px",
              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
            }}
          >
            <img
              src={probingImage}
              alt="Shared Image"
              style={{
                width: "150%",
                maxWidth: "150px",
                marginBottom: "10px",
                height: "100%",
              }}
            />
            <h3 className="text-sm font-bold text-gray-800">
              {card || 'Card Name Missing'}
            </h3>
          </motion.div>
        </motion.div>
      </div>
    ))}
  </div>
) : (
  <p className="text-gray-500 mt-4">No cards available.</p>
)}

      {/* Opened Cards Section */}
<div className="mt-4">
  {openedCards.length > 0 && (
    <div className="w-full bg-gray-900 text-white p-4 mb-6 rounded-lg">
      <h3 className="text-lg font-bold mb-2">Opened Cards:</h3>
      <div className="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-5 gap-4">
        {openedCards.map((card, index) => (
          <div className="scene" style={{ perspective: "1000px" }} key={index}>
            <motion.div
              className="card"
              style={{
                width: "200px",
                height: "300px",
                position: "relative",
                transformStyle: "preserve-3d",
                transition: "transform 1s",
                transform: "rotateY(180deg)", 
              }}
            >
              <motion.div
                className="card_face card_face--back"
                style={{
                  position: "absolute",
                  width: "100%",
                  height: "100%",
                  backfaceVisibility: "hidden",
                  transform: "rotateY(180deg)",
                  backgroundColor: "#ffffff",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "10px",
                  borderRadius: "8px",
                  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                }}
              >
                <img
                  src={probingImage}
                  alt="Shared Image"
                  style={{
                    width: "150%",
                    maxWidth: "150px",
                    marginBottom: "10px",
                    height: "100%",
                  }}
                />
                <h3 className="text-sm font-bold text-gray-800">
                  {typeof card === "object" ? card.cardname : card || 'Card Name Missing'}
                </h3>
              </motion.div>
            </motion.div>
          </div>
        ))}
      </div>
    </div>
  )}
</div>
   
   {/* Response Section */}
    {response && (
      <div className="w-full bg-white text-black p-4 mb-6 rounded-lg text-xl">
        <h3 className="text-lg font-bold mb-2">Response:</h3>
        <p className="text-lg text-black">{response}</p>
      </div>
    )}

     {/* Score Response Section */}
   {score && (
      <div className="w-full bg-white text-black p-4 mb-6 rounded-lg text-xl">
        <h3 className="text-lg font-bold mb-2">Score:</h3>
        <p className="text-md text-black">{score}</p>
      </div>
    )}

    {/* Error Section */}
    {error && (
      <div className="w-full bg-red-900 text-white p-4 mb-6 rounded-lg">
        <h3 className="text-lg font-bold mb-2">Error:</h3>
        <p className="text-md text-red-300">{error}</p>
      </div>
    )}
    </div>
  </div> 
  );
};

export default CardScenario;
